module.exports = __webpack_public_path__ + "img/total-district.977e0b7b.svg";